var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.963 14.4834C27.963 7.03775 21.9271 1.00188 14.4815 1.00188C7.03586 1.00188 0.999998 7.03775 0.999999 14.4834C1 21.929 7.03587 27.9648 14.4815 27.9648C21.9271 27.9648 27.963 21.929 27.963 14.4834Z",
    stroke: "#9B9B9B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1364_14553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2381 16.7768C10.5506 16.4836 11.0388 16.4836 11.3513 16.7768L13.7146 19.0125V10.8815C13.7087 10.854 13.7048 10.8265 13.7048 10.799V7.82113C13.7048 7.59939 13.8962 7.41797 14.1345 7.41797H14.8669C15.1032 7.41797 15.2966 7.59756 15.2966 7.82113V9.27251H15.3024C15.3024 9.30733 15.2966 9.34031 15.2966 9.37513V19.0125L17.6598 16.7951C17.9723 16.5019 18.4606 16.5019 18.773 16.7951C19.0855 17.0883 19.0855 17.5465 18.773 17.8397L15.0622 21.3215C14.7497 21.6147 14.2614 21.6147 13.9489 21.3215L10.2381 17.8397C10.0818 17.6931 10.0037 17.5098 10.0037 17.3082C10.0037 17.125 10.0818 16.9234 10.2381 16.7768Z",
    fill: "#9B9B9B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1364_14553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.0037,
    height: 14.1235,
    fill: "white",
    transform: "matrix(-1 0 0 1 19.0074 7.41797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadGray);
export default __webpack_public_path__ + "static/media/download-gray.a72893d107d39c90af4e05d970c25db4.svg";
export { ForwardRef as ReactComponent };